// Generated from D:/PJ/ieum/ieum-auto/apps/realtorauto-web/components/realtorauto/RealtorAutoTemplateSettingsFrame.tsx
// Source SHA-256: 3eca69e1b0bd8daf8e93ffdabeb6d134b66e14690ed62fccadc55b201d384308
// 원본 RealtorAuto 편집기 동기화 파일입니다. 직접 수정하지 말고 syncRealtorAutoOriginalTemplateEditor.cjs를 실행하세요.
'use client';

import { ArrowRight, Loader2, RefreshCw } from 'lucide-react';
import { memo } from 'react';
export const RealtorAutoTemplateSettingsFrame = memo(function RealtorAutoTemplateSettingsFrame({
  loading,
  message,
  error,
  categories,
  templates,
  children,
  pendingDialog,
  onRefresh,
  onBack,
  onSelectCategory,
  onSelectTemplate
}) {
  return <section className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm" data-template-settings-page>
      <div className="flex flex-wrap items-start justify-between gap-3 border-b border-slate-200 pb-4">
        <div>
          <h2 className="text-lg font-semibold">문서 템플릿 설정</h2>
          <p className="mt-1 text-sm text-slate-500">계약서, 확인설명서, 리포트, 안내문 텍스트 레이어</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <button type="button" onClick={onRefresh} disabled={loading} className="inline-flex h-10 items-center gap-2 rounded-lg border border-slate-300 bg-white px-3 text-sm font-semibold text-slate-700 hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden /> : <RefreshCw className="h-4 w-4" aria-hidden />}
            새로고침
          </button>
          <button type="button" onClick={onBack} className="inline-flex h-10 items-center gap-2 rounded-lg border border-slate-300 bg-white px-3 text-sm font-semibold text-slate-700 hover:bg-slate-100">
            <ArrowRight className="h-4 w-4 rotate-180" aria-hidden />
            계약방
          </button>
        </div>
      </div>

      {message ? <div className="mt-4 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm font-semibold text-emerald-700">
          {message}
        </div> : null}
      {error ? <div className="mt-4 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm font-semibold text-rose-700">
          {error}
        </div> : null}

      <div className="mt-5 space-y-4">
        <div className="grid gap-3 md:grid-cols-2">
          {categories.map(category => <button key={category.key} type="button" onClick={() => onSelectCategory(category.key)} className={`rounded-lg border p-4 text-left transition ${category.selected ? 'border-blue-400 bg-blue-50 text-blue-950' : 'border-slate-200 bg-white text-slate-600 hover:border-blue-200'}`}>
              <div className="text-sm font-semibold">{category.label}</div>
              <div className="mt-1 text-xs leading-5 text-slate-500">{category.description}</div>
            </button>)}
        </div>

        <div className="space-y-4">
          <div className="rounded-lg border border-slate-200 bg-slate-50 p-3" data-template-selector-strip>
            <div className="mb-2 flex items-center justify-between gap-3">
              <div className="text-xs font-semibold text-slate-500">템플릿</div>
              <div className="text-[11px] font-semibold text-slate-400">{templates.length.toLocaleString('ko-KR')}개</div>
            </div>
            <div className="flex gap-2 overflow-x-auto pb-1" role="tablist" aria-label="템플릿 선택">
            {templates.map(item => <button key={item.key} type="button" onClick={() => onSelectTemplate(item.key)} role="tab" aria-selected={item.selected} className={`min-h-[72px] w-[172px] shrink-0 rounded-lg border px-3 py-3 text-left transition ${item.selected ? 'border-blue-400 bg-blue-50 text-blue-950' : 'border-slate-200 bg-white text-slate-600 hover:border-blue-200'}`}>
                <div className="truncate text-sm font-semibold">{item.label}</div>
                <div className="mt-2 text-[11px] font-semibold text-slate-400">v{item.version}</div>
              </button>)}
            </div>
          </div>

          {children}
        </div>
      </div>
      {pendingDialog ?? null}
    </section>;
});
